import { ConfigLanguageCodeEnum } from 'common/helper/config/language-code.enum';

export function languageGetName(languageCode: ConfigLanguageCodeEnum): string {
  /**
   * Mapping language identifier to language label
   */
  const mapping: { [key: string]: string } = {
    en: 'English',
    ar: 'Arabic',
    fr: 'French',
  };

  return mapping[languageCode] || '';
}
